import {
  getAllControllerData,
  parseUrl
} from "@/components/common/controlBar/controlBarDialog/metaComponent/utils.js";
import {updateTranslateRes} from "@/components/common/controlBar/utils.js";
import {walkAllMetaComponentList} from "@/components/common/controlBar/controlBarDialog/metaComponent/worker.js";
import {
  isLanguagePackageType
} from "@/components/common/controlBar/controlBarDialog/metaComponent/textInput/languagePackage.js";




const English = 1
const Chinese = 2
export const mainLanguages = [
  Chinese, English
]




export function getCurrentPageId(){
  var id = parseUrl(location.href).params.id
  return Number(id)
}

export function isInMainLanguage(languageId = mm.store.state.currentLanguage){
  if(mainLanguages.includes(languageId)){
    return true
  }else{
    return false
  }
}

function getTranslateJson(node){
  var currentLanguage = mm.store.state.currentLanguage
  var translateJson = (()=>{
    if(node.componentName === 'banner_item'){
      if(node.translateRes[currentLanguage]){
        return node.translateRes[currentLanguage].imgAttr
      }else{
        return {}
      }

    }else{
      return node.translateRes[currentLanguage]
    }
  })()
  if(!translateJson){
    translateJson = (()=>{
      if(node.componentName === 'banner_item'){
        return node.translateRes[mm.store.state.authInfo.main_langset_id].imgAttr
      }else{
        return node.translateRes[mm.store.state.authInfo.main_langset_id]
      }
    })()
  }
  return translateJson
}

export function asyncTranslateResIntoNodeData(node){
  if(node.translateRes){
    var translateJson = getTranslateJson(node)

    for(var key in translateJson){
      if(Object.prototype.toString.call(translateJson[key]) === '[object Object]'){
        for(var subKey in translateJson[key]){
          if(!isLanguagePackageType(node.data[key][subKey])){
            node.data[key][subKey] = translateJson[key][subKey]
          }
        }
      }else{
        if(!isLanguagePackageType(node.data[key])){
          if(node.componentName === 'banner_item'){
            if(node.imgAttr){
              node.imgAttr[key] = translateJson[key]
            }
          }else{
            node.data[key] = translateJson[key]
          }
        }

      }
    }
  }
  return node
}

export function isAllowEdit(node){
  var res = false
  if(node.actions){
    if(node.actions.includes('edit')){
      res = true
    }
  }else{
    if(node.controllerModule.hasOwnProperty('edit')){
      res = true
    }
  }
  return res
}

export function findTranslatePlaces(node){
  var arr = []
  if(isAllowEdit(node) || node.forceTranslate){
    if(!isLanguagePackageType(node.controllerModule.edit)){
      arr.push({
        type: 'edit',
        nodeId: node.id,
        value: node.controllerModule.edit,
      })
    }

  }
  walkAllMetaComponentList(node, (walkedMetaComponent, parent) => {
    if((!walkedMetaComponent.isHide || (walkedMetaComponent.isHide && node.forceTranslate)) && walkedMetaComponent.needTranslate){
      walkedMetaComponent.needTranslate.forEach((needTranslateItem)=>{

        if(!isLanguagePackageType(walkedMetaComponent.value[needTranslateItem])){
          arr.push({
            type: 'metaComponent',
            nodeId: node.id,
            customName: walkedMetaComponent.name[needTranslateItem],
            metaComponentParent: parent,
            value: walkedMetaComponent.value[needTranslateItem],
          })
        }
      })
    }
  })

  if(node.componentName === 'banner_item'){
    if(node.imgAttr){
      arr.push({
        type: 'banner_item',
        nodeId: node.id,
        key: 'alt',
        value: node.imgAttr.alt,
      })
      arr.push({
        type: 'banner_item',
        nodeId: node.id,
        key: 'title',
        value: node.imgAttr.title,
      })
    }
  }


  return arr
}


export function asyncNodeDataIntoTranslateRes(node){
  var translatePlaces = findTranslatePlaces(node)
  translatePlaces.forEach((translatePlace)=>{
    if(translatePlace.type === 'edit'){
      updateTranslateRes({
        node: node,
        languageId: mm.store.state.currentLanguage,
        type: 'edit',
        value: translatePlace.value,
        metaComponentParent: undefined,
        customName: undefined,
        key: undefined
      })
    }else if(translatePlace.type === 'metaComponent'){
      updateTranslateRes({
        node: node,
        languageId: mm.store.state.currentLanguage,
        type: 'metaComponent',
        value: translatePlace.value,
        metaComponentParent: translatePlace.metaComponentParent,
        customName: translatePlace.customName,
        key: undefined
      })
    }else if(translatePlace.type === 'banner_item'){
      updateTranslateRes({
        node: node,
        languageId: mm.store.state.currentLanguage,
        type: 'banner_item',
        value: translatePlace.value,
        metaComponentParent: undefined,
        customName: undefined,
        key: translatePlace.key
      })
    }
  })
  return node
}


